export default [
    {
      name: 'ManageLotteryResults',
      title: 'Manage Lottery Result',
      icon: 'mdi-axis',
    }
]
